"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSortIndicators = void 0;
var agUtils_1 = require("../base/agUtils");
function sortIndicatorsFromColDefs(colDefs) {
    return colDefs
        .filter(function (col) { return col.sort !== undefined && col.sort !== null; })
        .map(function (col) { return ({
        colId: col.colId,
        sort: col.sort,
    }); });
}
function sortIndicatorsFromColumns(columns) {
    return columns
        .filter(function (col) { return col.getSort() !== undefined && col.getSort() !== null; })
        .map(function (col) { return ({
        colId: col.getColId(),
        sort: col.getSort(),
    }); });
}
function createSortIndicators(columns) {
    if (agUtils_1.isColumn(columns[0])) {
        return sortIndicatorsFromColumns(columns);
    }
    return sortIndicatorsFromColDefs(columns);
}
exports.createSortIndicators = createSortIndicators;
//# sourceMappingURL=tableDescriptorSorting.js.map